export default __webpack_public_path__ + "static/media/aclv.cc1e66e5.svg";